import { useEffect } from "react";
import { useFormulaTemplatesPrefetch } from "./useFormulaTemplates";
import { useVariableDefinitionsPrefetch } from "./useVariableDefinitions";
import { useOpDataCatalogPrefetch } from "./useOpDataCatalog";

const usePrefetchFormulaReferences = (
  subCategoryId: string | null,
  enabled: boolean,
) => {
  const prefetchTemplates = useFormulaTemplatesPrefetch();
  const prefetchVariableDefinitions = useVariableDefinitionsPrefetch();
  const prefetchOpDataCatalog = useOpDataCatalogPrefetch();

  useEffect(() => {
    if (!enabled) return;
    if (subCategoryId) prefetchTemplates(subCategoryId);
    prefetchVariableDefinitions();
    prefetchOpDataCatalog();
  }, [
    enabled,
    subCategoryId,
    prefetchTemplates,
    prefetchVariableDefinitions,
    prefetchOpDataCatalog,
  ]);
};

export default usePrefetchFormulaReferences;
